module.exports = __webpack_public_path__ + "img/estimate.e00e4f06.png";